import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ScrollToTop from "react-scroll-to-top";

// Pages
// import Home from "./pages/home/Home";
// import Projects from "./pages/projects/Projects";
// import Articles from "./pages/articles/Articles";
// import Contact from "./pages/contact/Contact";
// import Login from "./pages/auth/Login";
// import Signup from "./pages/auth/Signup";
import NotFound from "./components/NotFound";
import Loader from "./components/Loader";

// Lazy imports
const LHome = React.lazy(() => import("./pages/home/Home"));
const LProjects = React.lazy(() => import("./pages/projects/Projects"));
const LArticles = React.lazy(() => import("./pages/articles/Articles"));
const LAdminPost = React.lazy(() => import("./components/admin/AdminPost"));
const LAdminProject = React.lazy(() => import("./components/admin/AdminProject"));
const LContact = React.lazy(() => import("./pages/contact/Contact"));
const LLogin = React.lazy(() => import("./pages/auth/Login"));
const LSignup = React.lazy(() => import("./pages/auth/Signup"));

const App = () => {
  return (
    // Routing

    <BrowserRouter>
        <Header />
            <ScrollToTop
                smooth={true}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "dodgerblue",
                    left: "3%",
                    bottom: "3%",
                }}
            />

            <Routes className="bg-gray-900">
                {/* <Route path="/" element={<Home />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/articles" element={<Articles />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} /> */}
                <Route
                    path="/"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LHome />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/projects"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LProjects />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/articles"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LArticles />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/mmspost"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LAdminPost />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/mmsproject"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LAdminProject />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/contact"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LContact />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/login"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LLogin />
                        </React.Suspense>
                    }
                />
                <Route
                    path="/signup"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <LSignup />
                        </React.Suspense>
                    }
                />
                <Route
                    path="*"
                    element={
                        <React.Suspense fallback={<Loader />}>
                            <NotFound />
                        </React.Suspense>
                    }
                />
            </Routes>
        <Footer />
    </BrowserRouter>
  );
};

export default App;
